import { baseRoutes } from "helpers/baseRoutes";

/**
 * Define access routes related to user management, including paths and icons using baseRoutes from the "helpers/baseRoutes" module.
 * @constant {Object} accessRoute
 */
const accessRoute = {
  USER_NUTRITION: {
    path: `${baseRoutes.adminBaseRoutes}/user-nutrition`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-list-thumb" />
      </span>
    ),
  },
  USER_NUTRITION_DETAILS: {
    path: `${baseRoutes.adminBaseRoutes}/user-nutrition`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-users" />
      </span>
    ),
  },
};

export default accessRoute;
